import React from 'react'

// Función para generar colores aleatorios únicos
const generateRandomColor = (index: number) => {
  const colors = [
    '#e74c3c',
    '#3498db',
    '#2ecc71',
    '#f39c12',
    '#9b59b6',
    '#1abc9c',
    '#e67e22',
    '#34495e',
    '#16a085',
    '#27ae60',
    '#2980b9',
    '#8e44ad',
    '#c0392b',
    '#d35400',
    '#7f8c8d',
    '#f1c40f',
    '#95a5a6',
    '#bdc3c7',
    '#5dade2',
    '#48c9b0',
    '#f8b739',
    '#eb984e',
    '#af7ac5',
    '#ec7063',
    '#52be80',
    '#ff6b6b',
    '#4ecdc4',
    '#45b7d1',
    '#f9ca24',
    '#6c5ce7',
    '#a29bfe',
    '#fd79a8',
    '#fdcb6e',
    '#00b894',
    '#00cec9',
    '#0984e3',
    '#6c5ce7',
    '#e17055',
    '#fab1a0',
    '#ff7675'
  ]
  return colors[index % colors.length]
}

const CustomizedContent: React.FC<any> = (props) => {
  const {
    dataRender,
    selectedCluster,
    setSelectedCluster,
    enabled,
    isMobile,
    x,
    y,
    width,
    height,
    name,
    value,
    index
  } = props

  const fillColor = generateRandomColor(index)

  const handleClick = (e: React.MouseEvent) => {
    if (!selectedCluster && enabled) {
      e.stopPropagation()
      const clusterData = dataRender.find((c) => c.cluster === name)
      if (clusterData) {
        setSelectedCluster(clusterData)
      }
    }
  }

  const area = width * height
  let fontSize = 12

  // Ajustar tamaño de fuente según área y si es móvil
  if (isMobile) {
    if (area < 3000) {
      fontSize = 8
    } else if (area < 5000) {
      fontSize = 9
    } else if (area < 10000) {
      fontSize = 10
    } else if (area < 20000) {
      fontSize = 12
    } else if (area < 40000) {
      fontSize = 14
    } else if (area < 60000) {
      fontSize = 16
    } else {
      fontSize = 18
    }
  } else {
    if (area < 5000) {
      fontSize = 10
    } else if (area < 10000) {
      fontSize = 11
    } else if (area < 20000) {
      fontSize = 13
    } else if (area < 30000) {
      fontSize = 15
    } else if (area < 50000) {
      fontSize = 18
    } else if (area < 80000) {
      fontSize = 22
    } else if (area < 120000) {
      fontSize = 26
    } else {
      fontSize = 30
    }
  }

  const text = `${name} (${value})`
  // Ajustar el factor de caracteres por línea
  const charsPerLine = Math.floor(width / (fontSize * (isMobile ? 0.5 : 0.6)))

  // Caso 1: El texto cabe en una sola línea
  if (text.length <= charsPerLine) {
    return (
      <g onClick={handleClick} style={{ cursor: selectedCluster ? 'default' : 'pointer' }}>
        <rect
          x={x}
          y={y}
          width={width}
          height={height}
          style={{
            fill: fillColor,
            stroke: '#fff',
            strokeWidth: 2
          }}
        />
        <text
          x={x + width / 2}
          y={y + height / 2}
          textAnchor="middle"
          dominantBaseline="middle"
          fill="#fff"
          stroke="none"
          fontSize={fontSize}
          fontWeight={400}
          style={{
            pointerEvents: 'none'
          }}
        >
          {text}
        </text>
      </g>
    )
  }
  const maxCharsVertical = Math.floor(height / (fontSize * 1.2))
  const isVeryNarrow = width < height * 0.25 // Ancho es menos de 1/4 del alto
  if (isVeryNarrow && maxCharsVertical >= 3) {
    const verticalText = text.length > maxCharsVertical ? text.slice(0, maxCharsVertical - 3) + '...' : text

    return (
      <g onClick={handleClick} style={{ cursor: selectedCluster ? 'default' : 'pointer' }}>
        <rect
          x={x}
          y={y}
          width={width}
          height={height}
          style={{
            fill: fillColor,
            stroke: '#fff',
            strokeWidth: 2
          }}
        />
        <text
          x={x + width / 2}
          y={y + height / 2}
          textAnchor="middle"
          dominantBaseline="middle"
          fill="#fff"
          stroke="none"
          fontSize={fontSize}
          fontWeight={400}
          style={{
            pointerEvents: 'none',
            writingMode: 'sideways-rl',
            textOrientation: 'mixed'
          }}
        >
          {verticalText}
        </text>
      </g>
    )
  }
  // Caso 3: Rectángulo con altura suficiente para dos líneas
  const minHeightForTwoLines = isMobile ? 35 : 50
  if (height > minHeightForTwoLines) {
    const line1 = name.length > charsPerLine ? name.slice(0, charsPerLine - 3) + '...' : name
    const line2 = `(${value})`

    return (
      <g onClick={handleClick} style={{ cursor: selectedCluster ? 'default' : 'pointer' }}>
        <rect
          x={x}
          y={y}
          width={width}
          height={height}
          style={{
            fill: fillColor,
            stroke: '#fff',
            strokeWidth: 2
          }}
        />
        <text
          x={x + width / 2}
          y={y + height / 2 - fontSize / 2}
          textAnchor="middle"
          dominantBaseline="middle"
          fill="#fff"
          stroke="none"
          fontSize={fontSize}
          fontWeight={400}
          style={{
            pointerEvents: 'none'
          }}
        >
          {line1}
        </text>
        <text
          x={x + width / 2}
          y={y + height / 2 + fontSize / 2 + 4}
          textAnchor="middle"
          dominantBaseline="middle"
          fill="#fff"
          stroke="none"
          fontSize={fontSize - 1}
          fontWeight={400}
          style={{
            pointerEvents: 'none'
          }}
        >
          {line2}
        </text>
      </g>
    )
  }

  // Caso 4: Rectángulo pequeño con una sola línea truncada
  const displayText = text.length > charsPerLine ? text.slice(0, charsPerLine - 3) + '...' : text

  return (
    <g onClick={handleClick} style={{ cursor: selectedCluster ? 'default' : 'pointer' }}>
      <rect
        x={x}
        y={y}
        width={width}
        height={height}
        style={{
          fill: fillColor,
          stroke: '#fff',
          strokeWidth: 2
        }}
      />
      <text
        x={x + width / 2}
        y={y + height / 2}
        textAnchor="middle"
        dominantBaseline="middle"
        fill="#fff"
        stroke="none"
        fontSize={fontSize}
        fontWeight={400}
        style={{
          pointerEvents: 'none'
        }}
      >
        {displayText}
      </text>
    </g>
  )
}

export default CustomizedContent
